import React, { Fragment, useState } from "react";
import Breadcrumb from "../common/breadcrumb";
import data from "../../assets/data/listCoupons";
import Datatable from "../common/datatable";
import { Card, CardBody, CardHeader, Col, Container, Row, Table, Modal, ModalHeader, ModalBody, Button, ModalFooter } from "reactstrap";

const ListCoupons = () => {
	const [modal, setModal] = useState(false);
	const [selectedCoupon, setSelectedCoupon] = useState(null);

	const toggle = () => setModal(!modal);

	const openModalWithData = (coupon) => {
		setSelectedCoupon(coupon);
		toggle();
	};

	const tableHeaderStyle = {
		padding: "10px",
		textAlign: "left",
		background: "#f2f2f2",
		borderBottom: "1px solid #dee2e6",
	};

	const tableCellStyle = {
		padding: "10px",
		textAlign: "left",
		verticalAlign: "middle",
	};

	return (
		<Fragment>
			<Breadcrumb title="List Coupons" parent="Coupons" />
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<Card>
							<CardHeader>
								<h5>Coupons</h5>
							</CardHeader>
							<CardBody>
								<div
									id="batchDelete"
									className="category-table order-table coupon-list-delete"
								>
									<Table responsive>
										<thead style={{ borderBottom: "2px solid #dee2e6" }}>
											<tr>
												<th style={tableHeaderStyle}>ID</th>
												<th style={tableHeaderStyle}>Code</th>
												<th style={tableHeaderStyle}>Coupon Type</th>
												<th style={tableHeaderStyle}>Discount</th>
												<th style={tableHeaderStyle}>Status</th>
												<th style={{ ...tableHeaderStyle, textAlign: "center" }}>Action</th>
											</tr>
										</thead>
										<tbody>
											{data?.map((item, i) => (
												<tr key={i}>
													<td style={tableCellStyle}>{item.id}</td>
													<td style={tableCellStyle}>{item.code}</td>
													<td style={tableCellStyle}>{item.couponType}</td>
													<td style={tableCellStyle}>{item.amount}</td>
													<td style={tableCellStyle}>{item.status}</td>
													<td style={{ ...tableCellStyle, textAlign: "center" }}>
														<i
															className="fa fa-eye"
															style={{
																width: 35,
																fontSize: 20,
																padding: 11,
																cursor: "pointer",
																color: "#e4566e",
															}}
															onClick={() => openModalWithData(item)}
														></i>
													</td>
												</tr>
											))}
										</tbody>
									</Table>

									{/* <Datatable
										multiSelectOption={true}
										myData={data}
										pageSize={10}
										pagination={true}
										class="-striped -highlight"
									/> */}
								</div>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
			<Modal isOpen={modal} toggle={toggle}>
				<ModalHeader toggle={toggle}>Coupon Details</ModalHeader>
				<ModalBody>
					{selectedCoupon && (
						<Container fluid>
							<Row className="mb-2">
								<Col sm="5"><strong>ID:</strong></Col>
								<Col sm="7">{selectedCoupon.id}</Col>
							</Row>
							<Row className="mb-2">
								<Col sm="5"><strong>Code:</strong></Col>
								<Col sm="7">{selectedCoupon.code}</Col>
							</Row>
							<Row className="mb-2">
								<Col sm="5"><strong>Coupon Type:</strong></Col>
								<Col sm="7">{selectedCoupon.couponType}</Col>
							</Row>
							<Row className="mb-2">
								<Col sm="5"><strong>Discount Type:</strong></Col>
								<Col sm="7">{selectedCoupon.discountType}</Col>
							</Row>
							<Row className="mb-2">
								<Col sm="5"><strong>Amount:</strong></Col>
								<Col sm="7">{selectedCoupon.amount}</Col>
							</Row>
							<Row className="mb-2">
								<Col sm="5"><strong>Start Date/Time:</strong></Col>
								<Col sm="7">{selectedCoupon.startDate} {selectedCoupon.startTime}</Col>
							</Row>
							<Row className="mb-2">
								<Col sm="5"><strong>End Date/Time:</strong></Col>
								<Col sm="7">{selectedCoupon.endDate} {selectedCoupon.endTime}</Col>
							</Row>
							<Row className="mb-2">
								<Col sm="5"><strong>Maximum Uses:</strong></Col>
								<Col sm="7">{selectedCoupon.maximumUses}</Col>
							</Row>
							<Row className="mb-2">
								<Col sm="5"><strong>Max Amount Per Order:</strong></Col>
								<Col sm="7">{selectedCoupon.maxAmountPerOrder ?? 'N/A'}</Col>
							</Row>
							<Row>
								<Col sm="5"><strong>Status:</strong></Col>
								<Col sm="7">{selectedCoupon.status}</Col>
							</Row>
						</Container>
					)}
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={toggle}>Close</Button>
				</ModalFooter>
			</Modal>
		</Fragment>
	);
};

export default ListCoupons;
